module.exports = __webpack_public_path__ + "media/images/candidate-experience-mailer-report-0ae37ae72a9d500817cd77cf982349dd.png";